<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >

    </v-app-bar>
    <v-navigation-drawer
        permanent
        expand-on-hover
        app
    >
      <v-list>
        <v-list-item>
          <v-list-item-icon><v-icon>mdi-link</v-icon></v-list-item-icon>
          <v-list-item-title><router-link to="/links">Links</router-link></v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main app>
      <router-view></router-view>
    </v-main>
    <LoginDialog></LoginDialog>
  </v-app>
</template>

<script>
import LoginDialog from "@/components/LoginDialog";

export default {
  name: 'App',

  components: {
    LoginDialog
  },

};
</script>
